import Aos from "aos";
import { addDoc, collection } from "firebase/firestore";
import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/1.png";
import email from "../../assets/images/email.webp";
import locationIcon from "../../assets/images/locationIcon.webp";
import { Col, Container, Row } from "../../components/GridSystem";
import { useContextHook } from "../../Context/ContextOPen";
import { db } from "../../firebase";
import { content } from "../../lang/useLang";
import { ContactList } from "../../Context/Lists";

const ContactUs = ({}) => {
  const { direction } = useContextHook();
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    product: "",
  });
  const [isVisible, setIsVisible] = useState(false);
  const [animatedElements, setAnimatedElements] = useState({
    card: false,
    contactInfo: false,
    form: false,
    links: false,
    footer: false,
  });

  const contactRef = useRef(null);

  // تتبع ظهور القسم
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY >= 5000) {
        setIsVisible(true);
        // تفعيل الأنيميشن بالتسلسل
        setTimeout(
          () => setAnimatedElements((prev) => ({ ...prev, card: true })),
          200
        );
        setTimeout(
          () => setAnimatedElements((prev) => ({ ...prev, contactInfo: true })),
          400
        );
        setTimeout(
          () => setAnimatedElements((prev) => ({ ...prev, form: true })),
          600
        );
        setTimeout(
          () => setAnimatedElements((prev) => ({ ...prev, links: true })),
          800
        );
        setTimeout(
          () => setAnimatedElements((prev) => ({ ...prev, footer: true })),
          1000
        );
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "messages"), formData);
      alert("تم إرسال النموذج بنجاح!");
      setFormData({ name: "", phone: "", email: "", product: "" });
    } catch (error) {
      console.error("حدث خطأ عند الإرسال: ", error);
    }
  };

  useEffect(() => {
    Aos.init();
  }, []);

  return (
    <div
      ref={contactRef}
      className="min-h-screen relative overflow-hidden transition-all duration-1000"
      style={{ direction }}
    >
      {/* تأثيرات الخلفية المحسنة */}
      <div className="absolute inset-0 overflow-hidden">
        {/* أشكال هندسية عائمة */}
        <div className="absolute top-20 left-10 w-16 h-16 bg-slate-600/5 rounded-full animate-float-slow"></div>
        <div
          className="absolute top-40 right-20 w-12 h-12 bg-slate-500/5 rounded-full animate-float-medium"
          style={{ animationDelay: "2s" }}
        ></div>
        <div
          className="absolute bottom-32 left-1/4 w-20 h-20 bg-slate-600/3 rounded-full animate-float-slow"
          style={{ animationDelay: "4s" }}
        ></div>
        <div
          className="absolute bottom-20 right-32 w-14 h-14 bg-slate-500/4 rounded-full animate-float-medium"
          style={{ animationDelay: "1s" }}
        ></div>

        {/* خطوط متقاطعة */}
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-slate-500/10 to-transparent animate-scan-horizontal"></div>
        <div
          className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-slate-600/10 to-transparent animate-scan-horizontal"
          style={{ animationDelay: "2s" }}
        ></div>

        {/* شبكة خلفية */}
        <div className="absolute inset-0 opacity-5">
          <div
            className="w-full h-full"
            style={{
              backgroundImage: `radial-gradient(circle at 25% 25%, rgba(100, 116, 139, 0.1) 0%, transparent 50%), radial-gradient(circle at 75% 75%, rgba(71, 85, 105, 0.1) 0%, transparent 50%)`,
              backgroundSize: "50px 50px",
            }}
          ></div>
        </div>
      </div>

      <br />
      <br />

      <Container className="relative z-10 flex items-center">
        <div className="w-full">
          {/* البطاقة الرئيسية */}
          <div
            className={`relative transform transition-all duration-1000 ${
              isVisible && animatedElements.card
                ? "opacity-100 translate-y-0 scale-100"
                : "opacity-0 translate-y-10 scale-95"
            }`}
          >
            {/* تأثير خلفي للبطاقة */}
            <div className="absolute -inset-3 bg-gradient-to-r from-slate-600 via-slate-500 to-slate-400 rounded-3xl blur opacity-20 group-hover:opacity-30 transition duration-1000 group-hover:duration-200"></div>

            {/* البطاقة الرئيسية */}
            <div className="relative bg-gradient-to-br from-slate-800/90 to-slate-700/90 rounded-3xl overflow-hidden border border-slate-600/30 backdrop-blur-xl shadow-2xl">
              <div className="p-5">
                {/* الشعار والعنوان */}
                <div
                  className={`transition-all duration-1000 ${
                    isVisible && animatedElements.contactInfo
                      ? "opacity-100 translate-x-0"
                      : "opacity-0 -translate-x-6"
                  }`}
                >
                  <img src={logo} alt="" className="w-32 mx-auto mb-4" />
                </div>
                <Row className="items-start">
                  {/* نموذج الاتصال */}
                  <Col md={6} className="space-y-6">
                    <div
                      className={`bg-slate-700/60 rounded-2xl p-6 border border-slate-600/50 backdrop-blur-sm transition-all duration-1000 ${
                        isVisible && animatedElements.form
                          ? "opacity-100 translate-x-0"
                          : "opacity-0 translate-x-6"
                      }`}
                    >
                      <div className="space-y-3">
                        <div className="">
                          {/* الاسم */}
                          <div className="w-full">
                            <label className="block text-slate-200 font-medium mb-2">
                              {content.name}:
                            </label>
                            <input
                              onChange={handleChange}
                              value={formData.name}
                              name="name"
                              type="text"
                              className="w-full px-4 py-3 border border-slate-600/50 rounded-xl focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-slate-400 transition-all duration-300 bg-slate-600/30 text-white placeholder-slate-400"
                            />
                          </div>

                          {/* رقم الهاتف */}
                          <div className="w-full">
                            <label className="block text-slate-200 font-medium mb-2">
                              {content.phone_number}:
                            </label>
                            <input
                              onChange={handleChange}
                              value={formData.phone}
                              name="phone"
                              type="text"
                              className="w-full px-4 py-3 border border-slate-600/50 rounded-xl focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-slate-400 transition-all duration-300 bg-slate-600/30 text-white placeholder-slate-400"
                            />
                          </div>
                        </div>

                        {/* البريد الإلكتروني */}
                        <div>
                          <label className="block text-slate-200 font-medium mb-2">
                            {content.email}:
                          </label>
                          <input
                            onChange={handleChange}
                            value={formData.email}
                            name="email"
                            type="email"
                            className="w-full px-4 py-3 border border-slate-600/50 rounded-xl focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-slate-400 transition-all duration-300 bg-slate-600/30 text-white placeholder-slate-400"
                          />
                        </div>

                        {/* المنتج المهتم به */}
                        <div>
                          <label className="block text-slate-200 font-medium mb-2">
                            {content.product_you_are_interested}:
                          </label>
                          <select
                            onChange={handleChange}
                            value={formData.product}
                            name="product"
                            className="w-full px-4 py-3 border border-slate-600/50 rounded-xl focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-slate-400 transition-all duration-300 bg-slate-600/30 text-white"
                          >
                            <option
                              value=""
                              hidden
                              className="text-slate-800"
                            ></option>
                            {[1, 2, 3, 4, 5, 6, 7].map((e) => (
                              <option
                                key={e}
                                value={content["products_" + e]}
                                className="text-slate-800"
                              >
                                {content["products_" + e]}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/* زر الإرسال */}
                        <button
                          onClick={handleSubmit}
                          className="w-full bg-gradient-to-r from-slate-600 to-slate-500 hover:from-slate-500 hover:to-slate-400 text-white py-4 rounded-xl font-semibold hover:shadow-xl transform hover:scale-105 transition-all duration-300 shadow-lg shadow-slate-600/25 flex items-center justify-center gap-2 relative overflow-hidden group/btn"
                        >
                          {/* تأثير خلفية الزر */}
                          <div className="absolute inset-0 bg-gradient-to-r from-slate-500 to-slate-400 opacity-0 group-hover/btn:opacity-100 transition-opacity duration-300"></div>

                          {/* تأثير بريق عند التحويم */}
                          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -skew-x-12 animate-shine opacity-0 group-hover/btn:opacity-100 transition-opacity duration-1000"></div>

                          <span className="relative z-10">
                            {content.inquiry_send}
                          </span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-5 h-5 relative z-10"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </Col>
                  {/* معلومات الاتصال */}
                  <Col md={6} className="space-y-2">
                    <br />
                    {/* البريد الإلكتروني */}
                    <div
                      className={`p-3 bg-slate-700/50 rounded-xl border border-slate-600/50 hover:border-slate-400 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg group ${
                        isVisible && animatedElements.contactInfo
                          ? "opacity-100 translate-x-0"
                          : "opacity-0 -translate-x-6"
                      }`}
                      style={{ transitionDelay: "200ms" }}
                    >
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-gradient-to-r from-slate-600 to-slate-500 rounded-full flex items-center justify-center group-hover:scale-105 transition-transform duration-300 shadow-lg">
                          <img
                            src={email}
                            alt=""
                            className="w-5 h-5 filter brightness-0 invert"
                          />
                        </div>
                        <div className="text-slate-200 font-medium text-sm">
                          {content.email_1}
                        </div>
                      </div>
                    </div>

                    {/* العناوين */}
                    <Row>
                      {["UAE", "Oman", "Egypt", "Jordan"].map((e, i) => (
                        <Col key={i} md={6} className="!p-1">
                          <div
                            className={`p-3 h-full bg-slate-700/50 rounded-xl border border-slate-600/50 hover:border-slate-400 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg group ${
                              isVisible && animatedElements.contactInfo
                                ? "opacity-100 translate-x-0"
                                : "opacity-0 -translate-x-6"
                            }`}
                            style={{ transitionDelay: `${300 + i * 100}ms` }}
                          >
                            <div className="flex items-start gap-3">
                              <div className="w-10 h-10 bg-gradient-to-r from-slate-600 to-slate-500 rounded-full flex items-center justify-center group-hover:scale-105 transition-transform duration-300 shadow-lg flex-shrink-0">
                                <img
                                  src={locationIcon}
                                  alt=""
                                  className="w-5 h-5 filter brightness-0 invert"
                                />
                              </div>
                              <div className="flex-1 min-w-0">
                                <div className="text-slate-300 font-semibold text-base mb-1">
                                  {content[e]}
                                </div>
                                <div className="space-y-1">
                                  {content[e + "_"]
                                    ?.split(".")
                                    ?.filter((s) => s.trim())
                                    .map((s, i) => (
                                      <div
                                        className="text-slate-400 text-xs leading-tight"
                                        key={i}
                                      >
                                        {s.trim()}
                                      </div>
                                    ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </Col>
                </Row>

                {/* الروابط السريعة */}
                <div
                  className={`mt-2 transition-all duration-1000 ${
                    isVisible && animatedElements.links
                      ? "opacity-100 translate-y-0"
                      : "opacity-0 translate-y-6"
                  }`}
                >
                  <div className="flex justify-center items-center flex-wrap gap-6">
                    {ContactList.map((e, i) => (
                      <a
                        key={i}
                        href={e.link ? e.link : "https://wa.me/+971504681550"}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group relative"
                      >
                        <div className="absolute -inset-2 bg-gradient-to-r from-slate-600 to-slate-500 rounded-2xl blur opacity-0 group-hover:opacity-30 transition duration-500"></div>
                        <div className="relative w-16 h-16 bg-slate-700/50 rounded-2xl flex items-center justify-center shadow-lg hover:shadow-xl transform hover:scale-110 hover:-translate-y-1 transition-all duration-300 border border-slate-600/50 backdrop-blur-sm">
                          <img
                            src={e.image}
                            alt="contact_us"
                            className="w-8 h-8"
                          />
                        </div>
                      </a>
                    ))}
                  </div>
                </div>

                {/* حقوق النشر */}
                <div
                  className={`text-center mt-5 pt-5 border-t border-slate-600/50 transition-all duration-1000 ${
                    isVisible && animatedElements.footer
                      ? "opacity-100 translate-y-0"
                      : "opacity-0 translate-y-6"
                  }`}
                >
                  <div className="text-slate-400 text-sm mb-1">
                    {localStorage.getItem("language") === "ar"
                      ? "جميع الحقوق محفوظة لشركة سكاي سيتي للاعلانات الامارات العربية المتحدة"
                      : "sall Right Reserve to sky city advertisement Co.United Arab Emirates"}
                  </div>
                  <div className="text-slate-300 font-medium">
                    <Link
                      to="/privacy-policy"
                      className="hover:text-slate-200 transition-colors duration-300"
                    >
                      Privacy Policy
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>

      {/* الأنيميشن المخصصة */}
      <style jsx>{`
        @keyframes float-slow {
          0%,
          100% {
            transform: translateY(0px) rotate(0deg);
          }
          33% {
            transform: translateY(-15px) rotate(120deg);
          }
          66% {
            transform: translateY(8px) rotate(240deg);
          }
        }
        @keyframes float-medium {
          0%,
          100% {
            transform: translateY(0px) rotate(0deg);
          }
          33% {
            transform: translateY(-12px) rotate(-120deg);
          }
          66% {
            transform: translateY(6px) rotate(-240deg);
          }
        }
        @keyframes scan-horizontal {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(100%);
          }
        }
        @keyframes shine {
          0% {
            transform: translateX(-100%) skewX(-12deg);
          }
          100% {
            transform: translateX(200%) skewX(-12deg);
          }
        }
        @keyframes pulse-soft {
          0%,
          100% {
            opacity: 0.1;
            transform: scale(1);
          }
          50% {
            opacity: 0.2;
            transform: scale(1.05);
          }
        }
        .animate-float-slow {
          animation: float-slow 8s ease-in-out infinite;
        }
        .animate-float-medium {
          animation: float-medium 6s ease-in-out infinite;
        }
        .animate-scan-horizontal {
          animation: scan-horizontal 4s linear infinite;
        }
        .animate-shine {
          animation: shine 2s ease-in-out;
        }
        .animate-pulse-soft {
          animation: pulse-soft 10s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default ContactUs;
